import React, { useEffect, useRef, useState } from 'react';
import styles from './Form.module.scss';
import CheckBox from '../CheckBox/CheckBox';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import axios from 'axios';
import Device from '../../utils/mobile';
import { sort } from '../../utils/misc';
import Spinner from '../Spinner/Spinner';

const Form = ({
  background = '',
  padding = '',
  formBackground = '',
  color = '',
  handleClose = null,
  type = 1 /* 1 = J'ai un projet, 2 = Contacter l'entreprise */,
  services = [],
}) => {
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [entreprise, setEntreprise] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [project, setProject] = useState('');
  const [message, setMessage] = useState('');
  const [checkBox, setCheckBox] = useState(false);
  const captchaRef = useRef(null);

  const [submiting, setSubmiting] = useState(false);

  const checkBoxRef = useRef(null);
  const [messageConfirm, setMessageConfirm] = useState(null);

  const submit = (e) => {
    e.preventDefault();

    if (!checkBox) {
      checkBoxRef.current.style.color = 'red';
      return;
    }

    setSubmiting(true);

    // on exécute le captcha
    captchaRef.current.execute();
  };

  /**
   * Si le captcha s'est bien passé, on envoie
   */
  const send = () => {
    const formData = {
      firstname: firstname,
      lastname: lastname,
      entreprise: entreprise,
      service: type === 1 ? 'Commercial' : 'Direction',
      phone: phone,
      email: email,
      message: message,
    };

    axios
      .post('/api/contact', formData)
      .then(() => {
        setFirstname('');
        setLastname('');
        setEntreprise('');
        setPhone('');
        setEmail('');
        setProject('');
        setMessage('');
        setCheckBox(false);
        setSubmiting(false);

        setMessageConfirm('Votre message a bien été envoyé');
      })
      .catch((err) => {
        console.error(err);
        alert('Une erreur est survenue, merci de réessayer plus tard...');
      });
  };

  const onClosePopup = () => {
    if (handleClose) {
      handleClose();
    }
  };

  useEffect(() => {
    if (Device.check() === false) {
      location.hash = '';
      location.hash = 'form';
    }
  }, []);

  useEffect(() => {
    if (messageConfirm) {
      const top = document.getElementById('form').offsetTop;
      window.scrollTo(0, top);
    }
  }, [messageConfirm]);

  return (
    <>
      <div id={'form'} style={{ background: background }}></div>
      <div
        className={styles.Form}
        style={{ background: background, padding: padding }}
      >
        <div className={styles.Form__close}>
          <div onClick={onClosePopup} className={styles.Form__close__btn}>
            <img
              width='40'
              height='40'
              src='/img/svg/icn-close-blue.svg'
              alt='Fermer'
            />
          </div>
        </div>
        <div
          className={`${styles.Form__content} layout ${
            color && styles[`Form__${color}`]
          }`}
          style={{
            background: formBackground,
          }}
        >
          {color ? (
            <>
              {type === 1 && <h3>J'ai un projet</h3>}
              {type === 2 && <h3>Contacter l'entreprise</h3>}
            </>
          ) : (
            <h3>Prise de contact</h3>
          )}
          {messageConfirm && (
            <>
              <p className={styles.Form__content__confirm}>{messageConfirm}</p>
            </>
          )}

          {!messageConfirm && (
            <>
              <p>
                Quelques questions pour que nous puissions répondre au mieux à
                votre demande :
              </p>

              <form onSubmit={submit}>
                <div className={`${styles.Form__content__row} layout row`}>
                  <div className={styles.Form__content__row__input}>
                    <p>Votre prénom*</p>
                    <input
                      type='text'
                      name='firstname'
                      required
                      value={firstname}
                      onChange={(e) => setFirstname(e.target.value)}
                    />
                  </div>
                  <div className={styles.Form__content__row__input}>
                    <p>Votre nom*</p>
                    <input
                      type='text'
                      name='lastname'
                      required
                      value={lastname}
                      onChange={(e) => setLastname(e.target.value)}
                    />
                  </div>
                  <div className={styles.Form__content__row__input}>
                    <p>Votre Entreprise</p>
                    <input
                      type='text'
                      name='entreprise'
                      value={entreprise}
                      onChange={(e) => setEntreprise(e.target.value)}
                    />
                  </div>
                </div>
                <div className={`${styles.Form__content__row} layout row`}>
                  <div className={styles.Form__content__row__input}>
                    <p>Votre numéro de téléphone*</p>
                    <input
                      type='text'
                      name='phone'
                      required
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </div>
                  <div className={styles.Form__content__row__input}>
                    <p>Votre adresse e-mail*</p>
                    <input
                      type='text'
                      name='email'
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className={styles.Form__content__row__input}>
                    {type === 1 && (
                      <>
                        <p>Votre type de projet*</p>
                        <select
                          name='project'
                          required
                          value={project}
                          onChange={(e) => setProject(e.target.value)}
                        >
                          <option value='' disabled>
                            Sélection dans la liste
                          </option>
                          {sort(services, 'title').map((el, index) => (
                            <option
                              key={`opt-selprojet-${index}`}
                              value={el.title}
                            >
                              {el.title}
                            </option>
                          ))}
                          <option value='Projet autre'>Autre</option>
                        </select>
                      </>
                    )}
                    {type === 2 && (
                      <>
                        <p>Votre demande*</p>
                        <select
                          name='project'
                          required
                          value={project}
                          onChange={(e) => setProject(e.target.value)}
                        >
                          <option value='' disabled>
                            Sélection dans la liste
                          </option>
                          <option value='Administratif'>Administratif</option>
                          <option value='Recrutement'>Recrutement</option>
                          <option value='Contact autre'>Autre</option>
                        </select>
                      </>
                    )}
                  </div>
                </div>
                <div className={`${styles.Form__content__row} layout row`}>
                  <div className={styles.Form__content__row__input}>
                    {type === 1 ? (
                      <p>Les grandes lignes votre projet*</p>
                    ) : (
                      <p>Votre message*</p>
                    )}
                    <textarea
                      rows={12}
                      id='t-textarea'
                      required
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    ></textarea>
                  </div>
                </div>

                <HCaptcha
                  ref={captchaRef}
                  size={'invisible'}
                  sitekey={'fa05d692-6b14-45e7-a4de-1025b60734a9'}
                  onVerify={send}
                  onError={(err) => {
                    console.error(new Error(err));
                    alert(
                      'Une erreur est survenue, merci de réessayer plus tard...'
                    );
                  }}
                  onExpire={() => {
                    console.error(new Error('Captch expiré'));
                    alert(
                      'La vérification captcha a expiré, la page va se raffraichir'
                    );
                    window.location.reload(true);
                  }}
                />

                <div className={`${styles.Form__content__row} layout row`}>
                  <CheckBox
                    onChange={(val) => setCheckBox(val)}
                    checkBoxRef={checkBoxRef}
                    color={color}
                    text={
                      "En soumettant ce formulaire, j'accepte que les informations saisies soient exploitées dans le cadre de ma demande de contact"
                    }
                  />

                  {submiting === true ? (
                    <Spinner />
                  ) : (
                    <input
                      type='submit'
                      className={styles.Form__content__row__submit}
                      value='Envoyer'
                      id='t-form-submit'
                    />
                  )}
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Form;
